<template>
  <div class="badge-container">
    <slot />
    <div
      v-if="props.amount !== '1'"
      class="badge-container__badge"
    >
      {{ props.amount }}
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  amount: {
    type: String,
    default: '1',
    required: true,
  },
});
</script>

<style lang="scss">
</style>
